export enum StatisticsPeriod {
  Day = 1,
  Week = 7,
  Month = 31,
  Year = 365,
}
